module.exports = __webpack_public_path__ + "img/mouse.94134f75.png";